import { HOMEPAGE_SET_IN_STORE } from 'pages/home.page/actions';

const initialState = {
  videoLists: [],
  isLoaded: false,
};

export const homePageReducer = (state = initialState, action) => {
  switch (action.type) {
    case HOMEPAGE_SET_IN_STORE:
      return {
        videoLists: action.payload.collections,
        isLoaded: true,
      };

    default:
      return state;
  }
};
